import React from 'react';
import { BasicComponentProps } from 'types';

export type RadioInputOption = {
  disabled?: boolean;
  label?: string;
  style?: React.CSSProperties;
  value: string | number;
  crossOut?: boolean;
}

export enum RadioToggleThemes {
  DEFAULT = 'default',
  SQUARE = 'square',
}

export type RadioInputProps = {
  name: string;
  onChange?: (...value: any[]) => void;
  onHover?: (...value: any[]) => void;
  options: RadioInputOption[];
  size?: 'small' | 'medium' | 'large';
  useExternalState?: boolean,
  allowNone?: boolean,
  value?: string | number,
  theme?: RadioToggleThemes;
} & BasicComponentProps;
